<template>
    <div class="person-control-view">
        <!-- 创建布控组件 -->
        <!-- start @description: 右侧创建布控面板!-->
        <ioc-drawer :width="460" :title="$t('personCm.button.create')" :show-close="false" v-model="dialogVisible" :before-close="handleClose" :custom-class="drawerControl" :modal="false">
            <patrol-panel ref="patrolPanel" @submit="handleSubmit"></patrol-panel>
        </ioc-drawer>
        <!-- 布控摄像机组 -->
        <app-camers-group @change="carameChange" @cameraScatterPoint="cameraScatterPoint" type="2" :isRequired="true"></app-camers-group>
        <!-- start @description: 引入IGIS地图 !-->
    </div>
</template>

<script>
import { api } from '../api'
import { Dic } from '$utils'
import { setTimeout } from 'timers';
export default {
  components: {
    // 摄像机组组件
    AppCamersGroup: () => import('@components/app-camera-group'),
    // 布控维护面板
    PatrolPanel: () => import('../components/PatrolPanel')
  },
  data() {
    return {
      igisMap: null,
      iconObj: null,
      drawPoint: [],
      scatteIconObj: null,
      // 判断进入页面的标题
      formData: {
        bayonetList: []
      },
      // 默认抽屉关闭状态
      dialogVisible: false,
      modal: true,
      drawerControl: 'drawer-control'
    }
  },
  mounted() {
    this.dialogVisible = true
  },
  methods: {
    /*
     *@name: 摄像机撒点
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-06-22 11:23:20
    */
    cameraScatterPoint (cameraArr) {
      let cameraArrPoint = []
      let _self = this
      _self.$nextTick(() => {
        _self.igisMap = _self.$refs.igis.map
        _self.scatteIconObj = new window.iGis.layers.IconLayer({
          gisMapObj: _self.igisMap,
          isRef: true,
          isHover: true,
          layerOptions: {
            isBox: false,
            anchor: [10, -10]
          }
        })
        cameraArr.forEach(item => {
          cameraArrPoint.push({
            src: 'images/map/resource/camera.png',
            label: item.deviceName,
            coord: [item.longitude,item.latitude]
          })
        })
        _self.scatteIconObj.setData(cameraArrPoint, 0);
      })
    },
    /*
     *@name:取消-返回到布控列表页面
     *@param:{type} 
     *@description:返回到布控列表页面
     *@return:无
     *@author: zhengff
     *@date: 2019-05-02 22:06:00
    */
    handleClose() {
      this.$router.push({
        path: '/personControl/manage',
        name: 'manage'
      })
    },
     /*
     *@name: 摄像机组回调事件
     *@param:{type} 
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-05-08 23:17:12
    */
    carameChange(data = [], cameraArr = []){
      const bayonetList = []
      let filterArr = data.map(item => {
        return item.code
      })
      Array.from(new Set(filterArr)).forEach(item => {
        bayonetList.push({
          bayonetCode: item
        });
      })
      this.formData.bayonetList = bayonetList;

      this.igisMap = this.$refs.igis.map
      const _self = this
      this.iconObj && this.igisMap.removeLayer(this.iconObj)
      this.iconObj = new window.iGis.layers.IconLayer({
        gisMapObj: _self.igisMap,
        isRef: true,
        isHover: true,
        layerOptions: {
          isBox: false,
          anchor: [10, -10]
        }
      })
      _self.drawPoint.length = 0
      cameraArr.forEach(item => {
        _self.drawPoint.push({
          src: 'images/map/resource/camera_red.png',
          label: item.deviceName,
          coord: [item.longitude,item.latitude]
        })
      })
      this.iconObj.setData(_self.drawPoint, 0);
    },
    /*
     *@name:提交功能
     *@param:{type} 
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-04-30 18:04:39
    */
    handleSubmit() {
      console.log('新增布控任务')
      if (!this.formData.bayonetList.length) {
        this.$message.warning(this.$t('personCm.message.cameraGroup'))
        return false
      }
      let data = this.$refs['patrolPanel'].ruleForm
      let timeList = data.timeList
      let newTimeList = []
      let param = {
        name: data.name,
        confidenceThreshold: data.confidenceThreshold,
        startDate: data.startDate,
        endDate: data.endDate,
        type: data.type,
        hitType: data.hitType,
        bayonetList: this.formData.bayonetList,
        groupList: data.groupList
      }
      for (let i in timeList) {
        let t = i
        timeList[i].forEach(item => {
          console.log(item)
          let startTime = item.startTime.split('')
          let endTime = item.endTime.split('')
          newTimeList.push({
            startTime: startTime[0] + startTime[1] + ':' + startTime[2] + startTime[3] + ':' + startTime[4] + startTime[5],
            endTime: endTime[0] + endTime[1] + ':' + endTime[2] + endTime[3] + ':' + endTime[4] + endTime[5],
            day: i
          })
        })
      }
      param.timeList = newTimeList
      this.$fetch(api.addPersonnelTask, param).then(
        response => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return
          }
          this.$message.success(this.$t('personCm.message.createOk'))
          this.$router.push({path: '/personControl/manage'})
        }
      )
    }
  }
}
</script>
<style>
.person-control-view {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
